// extracted by css-extract-rspack-plugin
export default {"root":"root-Ix_BZ8","headerContainer":"headerContainer-RU7suJ","box":"box-G8yDmy","actions":"actions-vOpOnE","table":"table-h4SuHg"};